export function getActiveBanners(banners) {
  const today = new Date()
  const todayUTC = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate()))

  if (!banners || !Array.isArray(banners)) {
    return undefined
  }
  const activeBanners = banners
    .filter(b => {
      if (!b.enabled) return false
      const from = new Date(b.from_date)
      const to = new Date(b.to_date)
      return from <= todayUTC && todayUTC <= to
    })
    .map(b => {
      let bannerHTML = b.banner
      let originalHref = null
      let backgroundColor = null
      let fontColor = null

      // Extract first <a> and replace it with <u>, saving the href
      const anchorRegex = /<a\s+[^>]*href="([^"]+)"[^>]*>(.*?)<\/a>/i
      const anchorMatch = bannerHTML.match(anchorRegex)

      if (anchorMatch) {
        originalHref = anchorMatch[1]
        const anchorText = anchorMatch[2]
        bannerHTML = bannerHTML.replace(anchorRegex, `<u>${anchorText}</u>`)
      }

      // Extract first background-color and color from a style attribute
      const styleRegex = /style="[^"]*background-color:\s*(#[0-9a-fA-F]{6})[^"]*color:\s*(#[0-9a-fA-F]{6})[^"]*"/i
      const styleMatch = bannerHTML.match(styleRegex)

      if (styleMatch) {
        backgroundColor = styleMatch[1]
        fontColor = styleMatch[2]
      }

      return {
        ...b,
        banner: bannerHTML,
        originalHref,
        backgroundColor,
        fontColor
      }
    })

  console.log('getActiveBanners:', activeBanners)
  return activeBanners
}
